import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Grommet, TextInput, Image, Text } from "grommet";
import { debounce } from "lodash";
import React, { useCallback, useRef, useState } from "react";
import Avatar from "react-avatar";
import { useUser } from "../account/AccountStore";
import { GetOrganization, GetOrganizations } from "./IdentityAPI";
import { Organization } from "./OrganizationStore";
import SkeletonWrapper from "../components/SkeletonWrapper";

const OrganizationBlock = ({ id }) => {
    const [selectedOrganization, setSelectedOrganization] = useState({} as Organization);

    React.useEffect(() => {
        if (id) {
            GetOrganization(id).then((result) => {
                setSelectedOrganization(result);
            });
        }
    }, [id]);

    return (
        <Box direction="row-responsive" align="center">
            {!selectedOrganization.id && (
                <SkeletonWrapper loading={true}>
                    <></>
                </SkeletonWrapper>
            )}
            {selectedOrganization.id && (
                <Box align="center" gap="small" pad="small">
                    {selectedOrganization.logoUri && <Image src={selectedOrganization.logoUri} alt="" style={{ maxHeight: "35px", objectFit: "contain" }} />}
                    {!selectedOrganization.logoUri && <Avatar name={selectedOrganization.name} alt="" size="35px" />}
                    <Text>
                        <strong>{selectedOrganization.name}</strong>
                    </Text>
                </Box>
            )}
        </Box>
    );
};

export default OrganizationBlock;
